export default "assets/14d3f747ba8468e74c9beb965b315495.png";